import { z } from "zod";

export const coverLetterToneSchema = z.enum([
  "formal",
  "conversational",
  "enthusiastic",
]);

export const coverLetterSchema = z.object({
  id: z.string(),
  jobId: z.string().nullable(),
  resumeId: z.string().nullable(),
  title: z.string(),
  content: z.string(),
  tone: coverLetterToneSchema,
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type CoverLetter = z.infer<typeof coverLetterSchema>;
export type CoverLetterTone = z.infer<typeof coverLetterToneSchema>;
